import React, { useContext } from 'react';
import {
  Typography
} from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { PurchaseHistory } from '@one-thd/sui-icons';
import { TRACK } from '../../AddToConstants';
import { triggerAnalytics } from '../../AddToHelpers';

export const MODEL_NAME = 'pastOrdersTile';

/**
 * Tile component for adding materials from past orders
 */
export const PastOrdersTile = () => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const handleClick = () => {
    // 10.1 AI Entry Points - Track copy from past orders entry point click
    triggerAnalytics(TRACK.LIST_BUILDER_ENTRY_POINT_CLICK, {
      entryPoint: 'copy from past orders'
    });
    // Future implementation for past orders functionality
  };

  return (
    <div
      onClick={handleClick}
      role="button"
      tabIndex={0}
      aria-label="Copy materials from past orders"
      className="sui-h-full sui-flex sui-gap-2 sui-justify-center sui-items-center sui-cursor-pointer sui-paper-outlined sui-rounded-base sui-p-2"
    >
      <span className="sui-shrink-0 sui-flex sui-items-center">
        <PurchaseHistory size={isMobile ? 'small' : 'regular'} color="primary" />
      </span>
      <Typography variant={isMobile ? 'body-xs' : 'h6'} weight="bold">
        Copy from past orders
      </Typography>
    </div>
  );
};

export default PastOrdersTile;
